<template>
  <div class="grant-container">
    <div class="title-top">
      <h2 class="grant-container-title" @click="getGrants()">
        {{ languageKeys.TITLE }}
        <img v-show="loading" src="https://cdn.armut.com/images/preloader.gif" class="preloader" alt="loading...">
      </h2>

      <div class="actions">
        <button v-show="confirmations.indexOf('allConfirm_0') === -1" class="btn btn-danger mg-4" @click="toggleConfirm('allConfirm_0', true)">
          {{ languageKeys.REVOKE_ALL }}
        </button>
        <div v-show="confirmations.indexOf('allConfirm_0') > -1" class="revoke-confirm">
          <button class="btn btn-cancel mg-4" @click="toggleConfirm('allConfirm_0', false)">
            {{ languageKeys.CANCEL }}
          </button>
          <button class="btn btn-danger mg-4" @click="revokeAll()">
            {{ languageKeys.REVOKE_ALL }}
          </button>
        </div>
      </div>
    </div>

    <div class="grant-list">
      <div v-if="activeGrants.length === 0 && !loading && !currentGrant">
        <h4>{{ languageKeys.EMPTY_GRANTS }}</h4>
      </div>

      <div v-if="currentGrant !== null" class="grant-detail current">
        <h3>{{ languageKeys.CURRENT }}</h3>
        <div class="actions">
          <button v-show="confirmations.indexOf(currentGrant.jti) === -1" class="btn btn-danger mg-4" @click="toggleConfirm(currentGrant.jti, true)">
            {{ languageKeys.REVOKE }}
          </button>
          <div v-show="confirmations.indexOf(currentGrant.jti) > -1" class="revoke-confirm">
            <button class="btn btn-cancel mg-4" @click="toggleConfirm(currentGrant.jti, false)">
              {{ languageKeys.CANCEL }}
            </button>
            <button class="btn btn-danger mg-4" @click="revokeSingle(currentGrant.jti, true)">
              {{ languageKeys.REVOKE }}
            </button>
          </div>
        </div>
        <div>
          <p class="title">
            <span>{{
            currentGrant.clientName.replace("Armut", languageKeys.APP_NAME)
            }}</span>
          </p>
          <p class="detail">
            <span>{{ currentGrant.domain.replace("id.", "") }}</span>
            <span class="spacer" />
            <span class="spacer" />
            <span> <b>IP</b> </span>&nbsp;
            <span>{{ currentGrant.clientIp }}</span>
          </p>
          <p class="detail">
            <span>{{ currentGrant.userAgent }}</span>
          </p>
          <p class="detail">
            <span>
              <b>{{ languageKeys.VALID_FOR }}</b> </span>&nbsp;
            <span>{{ currentGrant.validity }} {{ languageKeys.DAYS }}</span>
            <span class="spacer" />
            <span>
              <b>{{ languageKeys.CREATEDATE }}</b> </span>&nbsp;
            <span>{{
            currentGrant.created.replace("T", " @ ").replace("Z", " ")
            }}</span>
            <span class="spacer" />
            <span>
              <b>{{ languageKeys.EXPIREDATE }}</b> </span>&nbsp;
            <span>{{
            currentGrant.expires.replace("T", " @ ").replace("Z", " ")
            }}</span>
          </p>
        </div>
      </div>

      <hr>

      <div v-for="grant in activeGrants" :key="grant.jti" class="grant-detail">
        <div class="actions">
          <button v-show="confirmations.indexOf(grant.jti) === -1" class="btn btn-danger mg-4" @click="toggleConfirm(grant.jti, true)">
            {{ languageKeys.REVOKE }}
          </button>
          <div v-show="confirmations.indexOf(grant.jti) > -1" class="revoke-confirm">
            <button class="btn btn-cancel mg-4" @click="toggleConfirm(grant.jti, false)">
              {{ languageKeys.CANCEL }}
            </button>
            <button class="btn btn-danger mg-4" @click="revokeSingle(grant.jti)">
              {{ languageKeys.REVOKE }}
            </button>
          </div>
        </div>

        <div>
          <p class="title">
            <span>{{
            grant.clientName.replace("Armut", languageKeys.APP_NAME)
            }}</span>
          </p>
          <p class="detail">
            <span>{{ grant.domain.replace("id.", "") }}</span>
            <span class="spacer" />
            <span class="spacer" />
            <span> <b>IP</b> </span>&nbsp;
            <span>{{ grant.clientIp }}</span>
          </p>
          <p class="detail">
            <span>{{ grant.userAgent }}</span>
          </p>
          <p class="detail">
            <span>
              <b>{{ languageKeys.VALID_FOR }}</b> </span>&nbsp;
            <span>{{ grant.validity }} {{ languageKeys.DAYS }}</span>
            <span class="spacer" />
            <span>
              <b>{{ languageKeys.CREATEDATE }}</b> </span>&nbsp;
            <span>{{
            grant.created.replace("T", " @ ").replace("Z", " ")
            }}</span>
            <span class="spacer" />
            <span>
              <b>{{ languageKeys.EXPIREDATE }}</b> </span>&nbsp;
            <span>{{
            grant.expires.replace("T", " @ ").replace("Z", " ")
            }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lang from '../language-keys';
import axios from 'axios';

export default {
  name: 'Grants',
  data() {
    return {
      loading: true,
      activeGrants: [],
      activeHs256Tokens: [],
      currentGrant: null,
      confirmations: [],
      languageKeys: {}
    };
  },
  mounted() {
    this.languageKeys = lang.getLanguageKeys();
    this.getGrants();
  },
  methods: {
    async getGrants() {
      const result = await this.request('list');

      if (result && !result.error) {
        this.activeGrants = result.data.grants.filter(g => !g.current);
        this.currentGrant = result.data.grants.filter(g => g.current)[0];
      }
    },
    toggleConfirm(jti, show) {
      if (show) {
        this.confirmations.push(jti);
      }
      else {
        this.confirmations.splice(this.confirmations.indexOf(jti), 1);
      }
    },
    async revokeSingle(jti, isCurrent) {
      this.activeGrants = this.activeGrants.filter(g => g.jti !== jti);
      await this.request('revokesingle', { jti });

      if (isCurrent) {
        this.redirectToLogin();
      }
    },
    async revokeAll() {
      await this.request('revokeall');
      await this.getGrants();
      this.toggleConfirm('allConfirm_0', false);
    },
    async request(action, data) {
      const headers = {
        'access_token': this.getCookie('UserApiToken') || '',
        'refresh_token': this.getCookie('RefreshToken') || '',
        'content-type': 'application/json'
      };

      let response = {};
      this.loading = true;

      try {
        const actionEndpoint = `https://${this.getIdentityHost()}/grants/${action}`;
        response = await axios.post(actionEndpoint, data, { headers });
        response.error = false;
      }
      catch (error) {
        response.error = true;
        response.status = (error.response || { status: 0 }).status;
      }

      if ([401, 403].indexOf(response.status) > -1) {
        console.log(response.status);
        this.redirectToLogin();
      }
      else {
        this.loading = false;
        return response;
      }
    },
    redirectToLogin() {
      window.location = `https://${this.getIdentityHost()}?returnUrl=${window.location.origin}`;
    },
    getCookie(name) {
      return (document.cookie.match(`(^|[^;]+)\\s*${name}\\s*=\\s*([^;]+)`) || []).pop();
    },
    getIdentityHost() {
      return window.location.hostname.replace('localhost', 'id.armut.test').replace('grants.', 'id.');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 800px) {
  .grant-container {
    width: 90%;
  }
}

@media (min-width: 800px) and (max-width: 1200px) {
  .grant-container {
    width: 70%;
  }
}

@media (min-width: 1200px) {
  .grant-container {
    width: 50%;
  }
}

.grant-container {
  margin: 0 auto;
}

.grant-container-title {
  cursor: pointer;
  display: inline-block;
  width: 100%;
}

.grant-container-title:hover {
  text-decoration: underline;
}

.grant-list {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 10px;
}

.grant-detail {
  padding: 10px;
  box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.2);
  background-color: white;
  font-size: 12px;
  position: relative;
}

.current {
  background-color: #4bff0026;
}

.current h3 {
  color: #9a9a9a;
}

.grant-detail .actions {
  position: absolute;
  top: 0;
  height: 100%;
  text-align: right;
}

.grant-detail .actions .revoke-confirm {
  font-weight: bold;
  text-align: right;
  color: #000000;
  height: 100%;
}

.rtl .grant-detail .actions {
  left: 0;
}

.ltr .grant-detail .actions {
  right: 0;
}

.title-top {
  display: flex;
}

.title-top .actions {
  margin-top: 14px;
  margin-right: -6px;
}

.title-top .revoke-confirm {
  width: 200px;
  text-align: right;
}

.grant-detail p {
  display: block;
  padding: 4px;
  margin: 0px;
}

.grant-detail .spacer {
  display: inline-block;
  width: 24px;
  height: 12px;
}

.grant-detail .title {
  font-size: 16px;
  color: #71b826;
  font-weight: bold;
}

.detail>* {
  display: inline-block;
}

.btn {
  outline: none;
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 12px;
  font-weight: normal;
  line-height: 1.4;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
}

.btn-danger {
  color: #fff;
  background-color: #d9534f;
  border-color: #d43f3a;
}

.btn-danger:hover {
  color: #fff;
  background-color: #c9302c;
  border-color: #ac2925;
}

.btn-cancel {
  color: #fff;
  background-color: #a5a5a5;
  border-color: #a1a1a1;
}

.btn-cancel:hover {
  color: #fff;
  background-color: #9b9b9b;
  border-color: #a1a1a1;
}

img.preloader {
  height: 22px;
  margin-left: 42px;
}

.mg-4 {
  margin: 4px;
}
</style>
